import { Scene } from "three";
import { EventsHandler } from "../RaycasterHandler/EventsHandler.js";
import { Globals } from "../Utils/Globals.js";
import { CameraUtils } from "../MultiviewRenderer/CameraUtils.js";
export class SceneBase extends Scene {
    camera;
    composer;
    meshes;
    _eventsHandler = new EventsHandler(this);
    onBeforeAnimate = null;
    onAfterAnimate = null;
    _smartRenderingCallback = () => this.needsRender = true;
    constructor(camera, meshesToRaycast, name = "") {
        super();
        this.name = name;
        if (camera == undefined) {
            console.error("Camera is mandatory.");
        }
        this.add(this.camera = camera);
        if (meshesToRaycast) {
            this.meshes = meshesToRaycast;
            this.add(this.meshes);
        }
        else {
            this.meshes = this;
        }
    }
    onWindowResize() {
        CameraUtils.updateCameraSize(Globals.canvasContainer.clientWidth, Globals.canvasContainer.clientHeight, this.camera);
        this.composer?.setSize(Globals.canvasContainer.clientWidth, Globals.canvasContainer.clientHeight);
        this._eventsHandler.triggerOnWindowResize();
    }
    animate() {
        this.onBeforeAnimate && this.onBeforeAnimate();
        this._eventsHandler.triggerEvents();
        this.onAfterAnimate && this.onAfterAnimate();
    }
    bindsmartRenderingEvent() {
        this.bindEvent(["onPositionComponentChange", "onRotationComponentChange", "onScaleComponentChange", "onChildAdded", "onWindowResize"], this._smartRenderingCallback);
    }
    unbindsmartRenderingEvent() {
        this._smartRenderingCallback && this.unbindEvent(["onPositionComponentChange", "onRotationComponentChange", "onScaleComponentChange", "onChildAdded", "onWindowResize"], this._smartRenderingCallback);
    }
}
//# sourceMappingURL=SceneBase.js.map